"use client";

const HEX_TILE_INNER_CLIP_CLASS =
	"origin-center [clip-path:var(--hex-tile-inner-clip)]";

export interface HexagonPathTileProps {
	isTranslucent?: boolean;
	isCompleted?: boolean;
	isCharacterActive?: boolean;
}

export function HexagonPathTile({
	isTranslucent = true,
	isCompleted = false,
	isCharacterActive = false,
}: HexagonPathTileProps) {
	return (
		<div
			className="sq-hex-path-tile pointer-events-none absolute inset-0"
			data-translucent={isTranslucent ? "true" : "false"}
			data-completed={isCompleted ? "true" : "false"}
			data-active={isCharacterActive ? "true" : "false"}
			aria-hidden
		>
			<div
				className={`sq-hex-path-tile-shell absolute inset-0 origin-center ${HEX_TILE_INNER_CLIP_CLASS}`}
			/>
			<div
				className={`sq-hex-path-tile-stroke absolute inset-0 origin-center scale-[var(--hexagon-inner-scale)] ${HEX_TILE_INNER_CLIP_CLASS}`}
			/>
			<div
				className={`sq-hex-path-tile-face absolute inset-0 origin-center scale-[var(--hexagon-path-face-scale)] ${HEX_TILE_INNER_CLIP_CLASS}`}
			/>
		</div>
	);
}
